<!-- 代表案例 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_case.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="detail w1200">
        <div class="title">{{ detail.title }}</div>
        <div class="rich" v-html="detail.contentStr"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
export default {
  components: { breadCrumb, SubNav },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
      detail: {},
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
    if (this.$route.params.id !== undefined) {
      this.getDetail();
    }
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find((ele) => {
        const firstPath = this.$route.path.split("/")[1];
        return ele.path != "/" && "/" + firstPath == ele.path;
      });
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    async getDetail() {
      let res = await this.$api.getNewInfo(this.$route.params.id);
      this.detail = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .detail {
    margin: 70px auto 120px;

    .title {
      text-align: center;
      font-size: 30px;
      color: #5e5d5d;
    }
    .rich {
      margin-top: 40px;
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .detail {
      margin: 30px 0;

      .title {
        font-size: 25px;
      }
      .rich {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        overflow: auto;
      }
    }
  }
}
</style>
